<template>
	<div class="innerBox">
		<h2 class="mb-4">Account Transaction</h2>

		<div class="mb-3 text-right">
			<button class="btn btn-primary">Create New Account</button>
		</div>
		<table class="table text-center" v-if="ready">
			<thead class="thead-dark">
				<th>No.</th>
				<th>Account Name</th>
				<th>Primary Account</th>
				<th>Balance</th>
				<th>Created At</th>
				<th>Deleted</th>
				<th colspan="2"><i class="fa fa-cog"></i></th>
			</thead>
			<tbody v-for="(account , index) in accountTransactionList" :key="index">
				<tr>
					<td>{{index + 1}}.</td>
					<td>{{account.account_name}}</td>
					<td>{{account.is_primary ? 'Yes' : 'No'}}</td>
					<td>Rp. {{account.balance ? numberWithCommas(account.balance) : 0}}</td>
					<td>{{moment(account.created_at).format('MMM DD, Y HH:mm')}}</td>
					<td :style="{'color' : account.deleted_at ? 'red' : 'green'}">{{account.deleted_at ? 'Yes' : 'No'}}</td>
					<td><button class="btn btn-outline-primary"><i class="fa fa-edit"></i></button></td>
					<td><button class="btn btn-outline-danger" @click="deleteAccount(account)"><i class="fa fa-trash"></i></button></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import moment from 'moment'

export default {
	data () {
		return {
			moment,
			accountTransactionList : null,
			ready : true
		}
	},
	mounted () {
		this.getAccountList()
	},
	methods : {
		getAccountList() {
			this.$http.get('/api/v1/transactions/account-list?showDeleted=true')
			.then((resp) => {
				this.accountTransactionList = resp.data.data
				

				for(var i = 0 ; i < this.accountTransactionList.length ; i++) {
					let index = i
					
					this.$http.get('/api/v1/transactions/account-balance?account_transaction_id=' + this.accountTransactionList[index].id)
					.then((resp) => {
						// curAccount.balance = resp.data.data
						this.$set(this.accountTransactionList[index] , 'balance' , resp.data.data)
					}).catch((err) => {
						console.log(err)
					})
				}

			})
			.catch((err) => {
				console.log(err)
			})
		},
		deleteAccount(account) {
			let id = account.id
			if(account.is_primary) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Diubah Primary Account Terlebih Dahulu sebelum menghapus akun tersebut.'])
				return
			}

			this.$http.delete('/api/v1/transactions/delete-account/' + id)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true , 'Akun telah berhasil di delete.'])
				this.getAccountList()
			})
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>